import BlogTimeline from "components/Blog/BlogTimeLine";
import { blogTbcarrer } from "i18n/blog";
import { useSelector } from "react-redux";
import CTAButton from "Util/CTAButton";
import React, { useState } from "react";
import {
  Search,
  ChevronLeft,
  ChevronRight,
  NotebookText,
  Minimize2,
  Grid2X2,
  Share2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import BlogCTA from "components/Blog/BlogCTA";
import usePageSEO from "hook/UsePageSEO";
import ShareModal from "components/Blog/ShareModal";
const Blogs = () => {
  const lang = useSelector((state) => state.language.lang);
  const [search, setSearch] = useState("");

  const seo = {
    en: {
      title: "Blog | TB Career",
      description:
        "Career advice, AI, startups, migration and life in New Zealand.",
    },
    vi: {
      title: "Blog | TB Career",
      description:
        "Chia sẻ về hướng nghiệp, AI, khởi nghiệp và cuộc sống tại New Zealand.",
    },
  };

  const s = seo[lang];

  const shareUrl = `https://tbcareer.com/blogs`;

  const imagePath = "https://tbcareer.com/blog/mainblog.jpg";

  usePageSEO({
    title: s.title,
    description: s.description,
    ogTitle: s.title,
    ogDescription: s.description,
    ogImage: imagePath,
    ogUrl: shareUrl,
    ogSite_name: "TB Career",
  });

  const [showAll, setShowAll] = useState(false);
  const [openShare, setOpenShare] = useState(false);

  const navigate = useNavigate();
  const blogs = [...blogTbcarrer].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  const filteredBlogs = blogs.filter((blog) => {
    const d = blog[lang];

    const keyword = search.toLowerCase().trim();

    if (!keyword) return true;

    return JSON.stringify(d).toLowerCase().includes(keyword);
  });

  const POSTS_PER_PAGE = 3;

  const [currentPage, setCurrentPage] = useState(1);

  const searchedBlogs = search.trim() ? filteredBlogs : blogs;

  const totalPages = Math.ceil(searchedBlogs.length / POSTS_PER_PAGE);

  const paginatedBlogs = searchedBlogs.slice(
    (currentPage - 1) * POSTS_PER_PAGE,
    currentPage * POSTS_PER_PAGE,
  );

  const displayedBlogs = showAll ? searchedBlogs : paginatedBlogs;

  //search blog

  return (
    <section className="py-24 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative mb-24 mt-16">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl lg:text-6xl font-bold text-navy ">
                {lang === "vi" ? "Bài Viết" : "Blog"}
              </h1>

              <div className="mt-5 w-16 h-1 rounded-full bg-neonYellow" />
            </div>
            <button
              onClick={() => setOpenShare(true)}
              className="flex items-center gap-2 text-navy hover:gap-3 transition"
            >
              <Share2 size={18} />
              Share
            </button>
          </div>

          <div className="flex justify-center my-12">
            <div className="relative w-full max-w-md">
              <Search
                size={18}
                className="
        absolute
        left-4
        top-1/2
        -translate-y-1/2
        text-gray-400
        pointer-events-none
      "
              />

              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder={
                  lang === "vi"
                    ? "Nhập từ khóa..."
                    : "Write your search here..."
                }
                className="
        w-full
        h-12
        rounded-xl
        border
        border-gray-300
        bg-white
        pl-11
        pr-4
        outline-none
        transition-all
        duration-300
        text-navy
        placeholder:text-gray-400
        focus:border-neonYellow
        focus:ring-4
        focus:ring-neonYellow/10
      "
              />
            </div>
          </div>
        </div>
        <BlogTimeline
          blogs={displayedBlogs}
          lang={lang}
          keyword={search}
        />{" "}
      </div>
      {!showAll && totalPages > 1 && (
        <div className="flex justify-center mt-12 lg:mt-16 px-4">
          <div className="flex items-center gap-2 lg:gap-3">
            {/* PREV */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="
        group
        flex items-center justify-center
        h-9 w-9
        lg:h-12 lg:w-12
        rounded-xl lg:rounded-2xl
        border border-gray-200
        bg-white
        text-navy/60
        disabled:opacity-30
        hover:bg-neonYellow
        hover:text-navy
        transition-all duration-300
      "
            >
              <ChevronLeft
                size={18}
                className="group-hover:-translate-x-0.5 transition-transform"
              />
            </button>

            {/* PAGE NUMBERS */}
            <div className="flex items-center gap-1 lg:gap-2">
              {(() => {
                const pages = [];

                // Mobile
                if (window.innerWidth < 1024) {
                  if (currentPage > 2) {
                    pages.push(1);

                    if (currentPage > 3) {
                      pages.push("...");
                    }
                  }

                  for (
                    let i = Math.max(1, currentPage - 1);
                    i <= Math.min(totalPages, currentPage + 1);
                    i++
                  ) {
                    pages.push(i);
                  }

                  if (currentPage < totalPages - 1) {
                    if (currentPage < totalPages - 2) {
                      pages.push("...");
                    }

                    pages.push(totalPages);
                  }
                } else {
                  // Desktop
                  for (let i = 1; i <= totalPages; i++) {
                    pages.push(i);
                  }
                }

                return pages.map((page, index) => {
                  if (page === "...") {
                    return (
                      <span
                        key={`ellipsis-${index}`}
                        className="w-6 text-center text-gray-400"
                      >
                        ...
                      </span>
                    );
                  }

                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`
                flex items-center justify-center
                h-9 w-9
                lg:h-12 lg:w-12
                rounded-xl lg:rounded-2xl
                text-xs lg:text-sm
                font-semibold
                transition-all duration-300
                ${
                  currentPage === page
                    ? `
                      bg-amber
                      text-navy
                      shadow-lg
                      scale-105
                    `
                    : `
                      bg-white
                      border border-gray-200
                      text-navy/60
                      hover:bg-neonYellow
                      hover:text-navy
                    `
                }
              `}
                    >
                      {page}
                    </button>
                  );
                });
              })()}
            </div>

            {/* NEXT */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="
        group
        flex items-center justify-center
        h-9 w-9
        lg:h-12 lg:w-12
        rounded-xl lg:rounded-2xl
        border border-gray-200
        bg-white
        text-navy/60
        disabled:opacity-30
        hover:bg-neonYellow
        hover:text-navy
        transition-all duration-300
      "
            >
              <ChevronRight
                size={18}
                className="group-hover:translate-x-0.5 transition-transform"
              />
            </button>
          </div>
        </div>
      )}
      <div className="flex justify-center mt-12">
        <CTAButton
          variant="outline"
          icon={showAll ? Minimize2 : Grid2X2}
          text={
            showAll
              ? lang === "vi"
                ? "Thu gọn"
                : "Show Less"
              : lang === "vi"
                ? "Xem tất cả"
                : "View All"
          }
          onClick={() => {
            setShowAll(!showAll);

            if (showAll) {
              setCurrentPage(1);

              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }
          }}
        />
      </div>
      <div className=" flex justify-center mx-auto">
        <BlogCTA />
      </div>
      <ShareModal
        open={openShare}
        onClose={() => setOpenShare(false)}
        url={shareUrl}
      />
    </section>
  );
};

export default Blogs;
